<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-18 16:24:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-01 16:33:34
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin-new/src/vab/components/VabEnterprise/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div style="margin: 0 10px">
    <div style="font-size: 14px; color: #fff">
      当前机构: {{ enterpriseData.name }}
      <el-button :round="true" size="small" type="primary" @click="changeEnterprise">切换机构</el-button>
    </div>
  </div>
</template>

<script>
  import { computed, defineComponent, toRefs, reactive } from 'vue'
  import { useStore } from 'vuex'
  import { useRoute, useRouter } from 'vue-router'
  import getPageTitle from '@/utils/pageTitle'
  import i18n from '@/i18n'
  import { gp } from '@vab'
  export default defineComponent({
    name: 'VabEnterprise',
    setup() {
      const state = reactive({
        enterpriseData: localStorage.getItem('isEnterpriseItem')
          ? JSON.parse(localStorage.getItem('isEnterpriseItem'))
          : {},
      })
      gp.$sub('changeEnterprise', (res) => {
        state.enterpriseData = JSON.parse(JSON.stringify(res[0]))
        console.log(res[0], state.enterpriseData)
      })

      const router = useRouter()

      const changeEnterprise = () => {
        localStorage.removeItem('isEnterpriseItem')
        router.replace('/index')
        gp.$pub('enterpriseChoose')
      }
      return {
        ...toRefs(state),
        changeEnterprise,
      }
    },
  })
</script>
